import moment from 'moment-timezone';

import { CALL_OUTCOME_LABEL_MAP, DATE_TIME_FORMAT } from '../../../constants';
import {
  applyServerTimezone,
  getFormattedPhoneNumber,
  secondsToTime,
} from '../../../helpers';

export const getFormattedCallLogs = callLogs =>
  callLogs.map(v => {
    const callDuration = secondsToTime(v.CallDuration);
    const callOutcome = v.CallOutcome
      ? CALL_OUTCOME_LABEL_MAP[v.CallOutcome]
      : '';
    const createdAt = moment(applyServerTimezone(v.DateAndTimeOfCall)).format(
      DATE_TIME_FORMAT.MM_DD_YYYY_hh_mm_A,
    );
    const phoneNumber = getFormattedPhoneNumber(
      v.ConnectedPhoneNumber || v.ContactPhoneNumber,
    );

    return {
      callDuration,
      callOutcome,
      callRecordingID: v.CallRecordingID,
      callerName: v.CallerName,
      contactCompany: v.ContactCompany,
      contactName: v.ContactName,
      createdAt,
      phoneNumber,
      tenant: v.Tenant,
    };
  });
